import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'isInvalidMessage',
    pure: false,
})
export class IsInvalidMessagePipe implements PipeTransform {
    transform(
        replyMessage: MessageDTO,
        constraints: Record<string, any>,
        hasAttachments: boolean,
        isHtmlContent: boolean,
    ): boolean {
        if (isHtmlContent) {
            if (!replyMessage?.html && !hasAttachments) {
                return true;
            }

            if (replyMessage?.text?.length > constraints?.maxReplyLength) {
                return true;
            }

            if (
                !HelperService.strip(replyMessage?.html).trim() &&
                !this.hasInlineImage(replyMessage?.html) &&
                !hasAttachments
            ) {
                return true;
            }
        } else {
            if (!replyMessage?.text && !hasAttachments) {
                return true;
            }

            if (replyMessage?.text?.length > constraints?.maxReplyLength) {
                return true;
            }
        }

        return false;
    }

    private hasInlineImage(html): boolean {
        if (html) {
            // @TODO improve this logic (such check doesn’t guarantee correct result in 100% percents because it checks word “img”, not img element)
            return html.includes('img');
        } else {
            return false;
        }
    }
}
